import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import moment from 'moment';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import PageTracker from '../../../common/PageTrackerHelper'

export default {
  name: 'ForceTripClose',
  components: {
    VueElementLoading,
    Paginate,
    Multiselect
  },
  mixins:[PageTracker],
  data: function() {
    return {
      pageno: 0,
      pagecount: 0,
      isLoading: false,
      localhubdetails:'',
      localuserid:'',
      localhubdetails:'',
      resultCount:0,
      tripResultData: [],
      TripPop: false,
      closekm: '',
      Tripsingle: {},
      getAllReasons: [],
      tripreason: '',
      ispoptripLoading: false,
      SearchSrId: '',
      userRoles: {},
      closeKmImg: '',
      openKmImg: '',
      kavachUserRoles : [],
      userDataKey : '',
      userRolesFE : []
    }
  },
  created: function() {
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];
    this.hubname = this.localhubdetails;
    this.userRoles = userdetail.userrole[0];
    this.kavachUserRoles = userdetail.userrole;
    this.userRolesFE = userdetail.userroleFE;
    if (this.userRoles && this.userRoles['rolename']) {
      this.userRoles['rolename'] = this.userRoles['rolename'].toLowerCase().trim();
    }
    //console.log("this.localhubdetails",this.localhubdetails);
    this.getAllTripList();
    this.getAllTripCloseReasons();


  },
  filters: {
    changeDateFormat: function(date) {
      if (date != null || date != '') {
        return moment(date).format('DD-MM-YYYY HH:mm:ss');
      }
    }
  },
  methods: {
    //to get pagination
    getPaginationData(pageNum) {
      this.pageno = (pageNum -1) * 10;
      this.getAllTripListData();
    },
    SearchTripdata(event){
      if(event.keyCode === 13) {
        this.getAllTripList();
      }
    },
    getAllTripList(){
      this.pageno = 0;
      this.$refs.paginate.selected= 0;
      this.getAllTripListData();
    },
    getAllTripListData() {
      this.isLoading = true;
      this.input = ({
        hubid: this.localhubdetails,
        limit: 10,
        offset: this.pageno
      })
      if(this.SearchSrId != ''){
        this.input.sruserid = this.SearchSrId;
      }
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'external/GetallLastmileTrips',
        'data': this.input
      })
      .then(result => {
        if(result.data.code == 200 ) {
          this.tripResultData = result.data.data.tripdata;
          this.resultCount = this.tripResultData.length;
          let totalRows = 0;
          if(result.data.data.count != undefined){
            totalRows = result.data.data.count;
          }
          this.resultCount = totalRows;
          if (totalRows < 10) {
              this.pagecount = 1
          } else {
              this.pagecount = Math.ceil(totalRows / 10)
          }
        } else {
          this.tripResultData = [];
          this.pagecount = 1;
          this.resultCount = 0;
        }
        this.isLoading = false;
      }, error => {
          console.error(error)
          this.isLoading = false;
      })
    },
      getTrip(tripId){
      this.TripPop = true;
      this.resetForm();
      this.ispoptripLoading = true;
      this.input = ({
          hubid: this.localhubdetails,
          limit: 10,
          offset: 0,
          tripid: tripId
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'external/GetallLastmileTrips',
          'data': this.input
      })
      .then(result => {
          this.Tripsingle = result.data.data.tripdata[0];
          this.closeKmImg = this.Tripsingle.closedspeedmeterurl
          this.openKmImg = this.Tripsingle.openspeedmeterurl
          this.ispoptripLoading = false;
      }, error => {
          console.error(error)
          this.ispoptripLoading = false;
      })
      this.TripPop = true;
    },
    getAllTripCloseReasons(){
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'external/CloseTripReasons',
        'data': ''
      })
      .then(result => {
        //console.log('result',result);
        if(result.data.code == 200) {
            this.getAllReasons = result.data.data;
        } else {
          this.getAllReasons = [];
        }
      }, error => {
        console.error(error)
      })
    },
    customLabel ({ reasonName }) {
      return `${reasonName}`
    },
    closeTripmodel(){
      this.TripPop = false;
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          let reqPayload = {
            tripid: this.Tripsingle.tripid,
            sruserid: this.Tripsingle.sruserid,
            hubid: this.hubname,
            km: this.closekm,
            tripstate:"closed",
            vehicleno: this.Tripsingle.vehicleno,
            operationType: "lastmile",
            reason: this.tripreason.reasonName,
            lastmodifiedby: this.localusermailid
          }
          //console.log('reqPayload',reqPayload);
          axios({
            method: 'POST',
            'url': apiUrl.api_url + 'external/SaveLastMileTrips',
            'data': reqPayload
          })
          .then(result => {
            //console.log('result',result.data);
            if( result.data.code === 200 ) {
              let TrackerInfo = {
                projectname:"Last Mile",
                type:"Web",
                userid:this.localuserid,
                username:this.localusermailid,
                meta: {
                    "event":"forceCloseTrip",
                    "tripid": this.Tripsingle.tripid,
                    "sruserid": this.Tripsingle.sruserid,
                    "hubid": this.hubname,
                    "km": this.closekm,
                    "tripstate":"closed",
                    "reason": this.tripreason.reasonName
                }
              }
              this.PageTracker(TrackerInfo);
              this.$alertify.success(result.data.message);
            } else {
              this.$alertify.error(result.data.message);
            }
            this.TripPop = false;
            this.resetForm();
            this.getAllTripList();
          }, error => {
            console.error(error)
            this.TripPop = false;
          })
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    loadCloseImageError(imageSrc) {
      //console.log('error',imageSrc);
      var srcLink = "static/img/defaultImg.png"
      this.closeKmImg = srcLink
    },
    loadOpenImageError(imageSrc, type) {
      var srcLink = "static/img/defaultImg.png"
      this.openKmImg = srcLink
    },
    resetForm() {
      this.Tripsingle = {};
      this.hubname = this.localhubdetails;
      this.pageno = 1;
      this.closekm = '';
      this.tripreason = '';
      this.closeKmImg = '';
      this.openKmImg = '';
      this.errors.clear();
      this.$validator.reset();
    }
  }
}
//extended validation
Validator.extend('isValidNumber', {
  getMessage: field => 'Please Enter only number.!',
  validate: value => {
    let numberRegex = /^[0-9]+$/;
    if(numberRegex.test(value) == true){
      return true;
    } else {
      return false;
    }
  }
})
//extended validation
Validator.extend('isValidKM', {
  getMessage: field => 'Please Enter greater than open km.!',
  validate: value => {
    let numberRegex = /^[0-9]+$/;
    let openkm =  $("#openkm").val();
    if( parseFloat(value) > parseFloat(openkm) ){
      return true;
    } else {
      return false;
    }
  }
})
Validator.extend('isValidDistance', {
  getMessage: field => 'Travel distance cannot be more than 200 KM/day.!',
  validate: value => {
    let numberRegex = /^[0-9]+$/;
    let openkm =  $("#openkm").val();
    console.log('openkm', openkm);
    let calculatekm = parseFloat(value) - parseFloat(openkm);
    console.log('calculatekm',calculatekm);
    if( calculatekm < 200 ){
      return true;
    } else {
      return false;
    }
  }
})



// WEBPACK FOOTER //
// ./src/views/components/ForceCloseTrip/ForceCloseTrip.component.js